// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal-m_CjZLlPg_BrmoTDkQfZAg {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  z-index: 9999;
  justify-content: center;
  align-items: center;
}

.Modal-m_fhR47xsHaJwQdZljvq2f {
  background-color: white;
  border-radius: 5px;
  padding: 2rem;
  min-width: 30%;
  color: var(--text);
}

.Modal-m_DY1txREKZo3QCWMzBq8N {
  display: flex;
  justify-content: space-between;
  align-items: center; 
  border-bottom: 1px solid var(--pies-lightgrey);
}

.Modal-m_w6cpEbSjCMotDAaplfXe {
  padding: 1rem 0;
}

.Modal-m_gP2YmNyIrfNypf4vdg6f {
  border-top: 1px solid var(--pies-lightgrey);
  display: flex;
  justify-content: right;
  padding: 1rem 0;
}

.Modal-m_gP2YmNyIrfNypf4vdg6f > div > * {
  margin-right: 1rem;
}

.Modal-m_kxQLdwXYTt_HdboLjsAK {
  margin: 1rem 0;
}
`, "",{"version":3,"sources":["webpack://./client/shared/genericComponents/Modal/Modal.m.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".overlay {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  z-index: 9999;\n  justify-content: center;\n  align-items: center;\n}\n\n.container {\n  background-color: white;\n  border-radius: 5px;\n  padding: 2rem;\n  min-width: 30%;\n  color: var(--text);\n}\n\n.headingContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; \n  border-bottom: 1px solid var(--pies-lightgrey);\n}\n\n.modalTitle {\n  padding: 1rem 0;\n}\n\n.buttonContainer {\n  border-top: 1px solid var(--pies-lightgrey);\n  display: flex;\n  justify-content: right;\n  padding: 1rem 0;\n}\n\n.buttonContainer > div > * {\n  margin-right: 1rem;\n}\n\n.modalContent {\n  margin: 1rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export var overlay = `Modal-m_CjZLlPg_BrmoTDkQfZAg`;
export var container = `Modal-m_fhR47xsHaJwQdZljvq2f`;
export var headingContainer = `Modal-m_DY1txREKZo3QCWMzBq8N`;
export var modalTitle = `Modal-m_w6cpEbSjCMotDAaplfXe`;
export var buttonContainer = `Modal-m_gP2YmNyIrfNypf4vdg6f`;
export var modalContent = `Modal-m_kxQLdwXYTt_HdboLjsAK`;
export default ___CSS_LOADER_EXPORT___;
